
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["initDecrypt"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "899528fb09b75a03053c.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			